import * as React from "react";
import { Text, Image, StyleSheet, View, TouchableOpacity } from "react-native";
// import { ScrollView } from "react-native-gesture-handler"; a part of cleaner code

import { useNavigation } from "@react-navigation/native";
// import UnderLine from "../components/AnimatedUnderLine"; a part of cleaner code
import { Ionicons } from "@expo/vector-icons";
import Barcode from "../components/Barcode";

import GlobalStyles from "../components/GlobalStyles";
import { useSelector } from "react-redux";

export default function BarCodeScreen() {
  const navigation = useNavigation();
  const MenuLogo = require("../assets/res/Aura_Alpha_Reversed_BlueBG.gif");
  const myreferFriendId = useSelector((state) => state.user.userData.subscriberDetails.referFriendId);
  // const BarCode = require("../assets/images/bar_code.png");

  return (
    <View style={GlobalStyles.containerMB}>
      <View style={GlobalStyles.bodyContainerT}>
        <View style={styles.HbuttonBar}>
          <TouchableOpacity
            style={styles.HbackButtonStyle}
            onPress={() => navigation.goBack()}
          >
            <Ionicons
              name="md-arrow-back"
              size={20}
              style={styles.HbackArrow}
            />
          </TouchableOpacity>
        </View>

        <View style={styles.containerA}>
          <Image
            style={styles.tinyLogo}
            source={MenuLogo}
            resizeMode="contain"
          />
        </View>

        <View style={[styles.containerB]}>
          {/* <Image style={styles.BarCode} source={BarCode} resizeMode="contain" /> */}
          <View
            style={{
              flex: 10,
              alignItems: "center",
              justifyContent: "center",
              paddingLeft: 100,
              paddingRight: 100,
            }}
          >
            <Barcode
            // subscriberDetails.referFriendId
              value = {myreferFriendId}
              //value="123456789999"
              //value="162683972362"
              options={{ format: "CODE128", background: "white", font: "courier"}}
            />
            {/* <Text style={styles.BarCodeText}>435 4897 576 1</Text> */}
          </View>
        </View>
        <View style={styles.containerC}>
         {/*  <TouchableOpacity
            style={styles.option}
            activeOpacity={0.5}
            //onPress={() => Linking.openURL(link.url)}
          >
            <View style={styles.SubmitButtonStyle}>
              <View style={styles.optionTextContainer}>
                <Text style={styles.optionText}>Add to Apple Wallet</Text>
              </View>
              <View style={styles.optionIconContainer}>
                <Ionicons
                  name={"md-arrow-forward"}
                  size={24}
                  color={"rgba(255,255,255,1)"}
                />
              </View>
            </View>
          </TouchableOpacity> */}
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  BarCode: {
    height: 110,
  },

  BarCodeText: {
    paddingTop: 10,
    alignSelf: "center",
    color: "#000000",
    fontFamily: "montserrat-bold",
    fontSize: 18,
    letterSpacing: 5,
  },

  option: {
    width: "100%",
    borderTopWidth: 1,
    borderLeftWidth: 0,
    borderBottomWidth: 1,
    borderRightWidth: 0,
    borderColor: "#dddddd",
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 0,
    paddingRight: 0,
    marginBottom: 5,
  },

  optionIconContainer: {
    marginLeft: 12,
  },

  optionText: {
    paddingTop: 3,
    alignSelf: "flex-start",
    color: "#FFFFFF",
    fontFamily: "montserrat-bold",
    fontSize: 14,
  },

  optionTextBlue: {
    paddingTop: 3,
    alignSelf: "flex-start",
    color: "#2F7696",
    fontFamily: "montserrat-bold",
    fontSize: 14,
  },

  SubmitButtonStyle: {
    flexDirection: "row",
  },

  optionTextContainer: {
    flex: 8,
  },

  optionIconContainer: {
    flex: 1,
  },

  HbuttonBar: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 0,
    marginTop: 25,
  },

  HbackArrow: {
    color: "#fff",
  },

  HbackButtonStyle: {
    marginTop: 5,
    paddingTop: 5,
    paddingBottom: 5,
    width: 75,
  },

  containerA: {
    alignItems: "center",
    justifyContent: "center",
    marginTop: 0,
  },

  containerB: {
    marginTop: 30,
    height: 200,
    backgroundColor: "#FFFFFF",
    borderRadius: 20,
    justifyContent: "center",
    alignItems: "center",
    paddingBottom: 20,
    paddingTop: 20,
  },

  containerC: {
    paddingTop: 30,
    paddingLeft: 50,
    paddingRight: 50,
    paddingBottom: 30,
  },

  tinyLogo: {
    height: 90,
    width: 240,
  },
  road: {
    height: 400,
    width: 353,
    alignSelf: "center",
  },
  logo: {
    width: 66,
    height: 58,
    resizeMode: "contain",
  },
  LinkBar: {
    width: 70,
    height: 4,
    backgroundColor: "#FFC72C",
    alignSelf: "center",
    marginTop: 10,
    marginBottom: 10,
  },
  TextStyleLink: {
    color: "#ffffff",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 14,
    paddingTop: 30,
  },
});
